module.exports = __webpack_public_path__ + "5e6be4908557c17aae95c8272dafcc20.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/head/Lankenau.jpg
// module id = 478
// module chunks = 0